import React from "react";
import classNames from 'classnames';

export const SpinLoader: React.FC<{className?: string}> = (props) =>
    <div className={'loader-wrapper'}>
        <div className={classNames('loader', props.className)}/>
    </div>
;